import cx from "classnames";

import { useCamera } from "../../contexts/camera";
import { CAMERA_ZOOM_BUTTON_FACTOR } from "../../game/gameConstants";
import { Icon } from "../icons/Icon";
import { StyledButtonContainer } from "../shared/StyledButtonContainer";
import "./CameraZoomButton.css";

export function CameraZoomButton(props: {
  direction: "in" | "out";
  className?: string;
}) {
  const { direction, className } = props;
  const [cameraCtx] = useCamera();

  const zoomCamera = () => {
    const boardCamera = cameraCtx.boardCamera;
    if (!boardCamera) return;

    const { camera, controls } = boardCamera;
    const zoom =
      direction === "in"
        ? camera.zoom * CAMERA_ZOOM_BUTTON_FACTOR
        : camera.zoom / CAMERA_ZOOM_BUTTON_FACTOR;

    controls.zoomTo(zoom, true);
  };

  return (
    <StyledButtonContainer
      className={cx("camera-zoom-button", className)}
      onClick={zoomCamera}
    >
      <Icon
        icon={direction === "in" ? "zoomIn" : "zoomOut"}
        className="camera-zoom-button-icon"
      />
    </StyledButtonContainer>
  );
}
